<template>

    <body class="dx-viewport">
        <DxDataGrid ref="dataGridRef" :allowColumnReordering="true" :data-source="dsDrepturiCustom"
            :allowColumnResizing="true" key-expr="ID" :columnAutoWidth="false" :columnMinWidth="50"
            :columnResizingMode="'nextColumn'" :show-borders="true" :syncLookupFilterValues="false"
            :filter-sync-enabled="true" show-row-lines="true" row-alternation-enabled="true" show-column-lines="false"
            @selection-changed="onSelectionChanged" @row-inserting="onRowInserting" @row-removing="onRowRemoving"
            class="border" @editing-start="onEditingStart">
            <DxSelection mode="single" />
            <DxFilterRow :visible="true" />
            <DxPaging :page-size="5" :page-index="1" />
            <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
            <DxSorting mode="multiple" />
            <DxStateStoring :enabled="true" :filterValue="false" storage-key="Drepturi" />
            <DxToolbar>
                <DxItem>
                    <template #default>
                        <DxButton icon="add" type="success" @click="onAddClick" />
                    </template>
                </DxItem>
                <DxItem>
                    <template #default>
                        <DxButton icon="refresh" @click="onRefreshClick" />
                    </template>
                </DxItem>
            </DxToolbar>
            <DxEditing :allowUpdating="true" :allowDeleting="true" mode="popup" @click="onRowRemoving">
                <DxPopup :closeOnOutsideClick="false" :showCloseButton="false" :width="550" :height="650">
                    <DxToolbarItem :template="customTitleTemplate" />
                    <DxToolbarItem toolbar="bottom" widget="dxButton" location="after"
                        :options="successButtonOptions" />
                    <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="dangerButtonOptions" />
                </DxPopup>
                <DxFormGrid>
                    <DxItem :col-span="1" :col-count="1" item-type="group">
                        <DxItem data-field="Nume" :editor-options="{ width: 510, disabled: true }" />
                        <DxItem data-field="Cod" :editor-options="{ width: 510, disabled: true }" />
                        <DxItem data-field="ModulID" editor-type="dxSelectBox"
                            :editor-options="{ dataSource: dsModule, valueExpr: 'ID', displayExpr: 'Nume', width: 510, showClearButton: true, placeholder: 'Selectați modulul...' }" />
                        <DxItem data-field="MeniuConfig" :editor-options="{ width: 510, height: 100 }" />
                        <DxItem data-field="Explicatie" :editor-options="{ width: 510, disabled: true, height: 100 }" />
                    </DxItem>
                </DxFormGrid>
            </DxEditing>
            <DxColumn data-field="Nume" />
            <DxColumn data-field="Cod" />
            <DxColumn data-field="Explicatie" />
            <DxColumn data-field="ModulID" caption="Modul">
                <DxLookup :data-source="dsModule" value-expr="ID" display-expr="Nume" />
            </DxColumn>
            <DxColumn data-field="Meniu" :visible="false" />
            <DxColumn data-field="MeniuConfig" />
        </DxDataGrid>
        <DxPopupAdd :visible.sync="isModalVisible" :closeOnOutsideClick="false" :showCloseButton="false"
            :showTitle="true" :width="550" :height="650">
            <template #title>
                <div
                    style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold;  padding: 10px; padding-left: 20px; ">
                    Adăugare
                </div>
            </template>
            <div>
                <DxForm :formData="formData">
                    <DxItem :col-span="1" :col-count="1" item-type="group">
                        <DxItem data-field="Nume" :editor-options="{ width: 510 }">
                            <DxValidationRule>
                                <DxRequiredRule />
                            </DxValidationRule>
                        </DxItem>
                        <DxItem data-field="Cod" :editor-options="{ width: 510 }">
                            <DxValidationRule>
                                <DxRequiredRule />
                            </DxValidationRule>
                        </DxItem>

                        <!-- <DxItem data-field="Meniu" editor-type="dxCheckBox"
                            :editor-options="{ width: 510, elementAttr: { style: 'margin-left:12px;' } }"
                            :label="{ text: 'Este meniu?', location: 'left' }" /> -->
                        <DxItem data-field="Meniu" :visible="false" />
                        <DxItem data-field="MeniuConfig" :editor-options="{ width: 510, height: 100 }">
                            <DxValidationRule>
                                <DxRequiredRule />
                            </DxValidationRule>
                        </DxItem>
                        <DxItem data-field="ModulID" editor-type="dxSelectBox"
                            :editor-options="{ dataSource: dsModule, valueExpr: 'ID', displayExpr: 'Nume', width: 510, showClearButton: true, placeholder: 'Selectați modulul...' }" />
                        <DxItem data-field="Explicatie" :editor-options="{ width: 510, height: 100 }" />
                    </DxItem>
                </DxForm>
                <div style="display: flex; justify-content: flex-end; gap: 8px;">
                    <DxButton text="Salvează" type="success" width="100" @click="onSaveAdd" />
                    <DxButton text="Închide" type="danger" width="100" @click="onCancel" />
                </div>
            </div>
        </DxPopupAdd>
    </body>
</template>
<script lang="ts">
import { defineComponent, ref } from 'vue';
import { DxButton } from 'devextreme-vue/button';
import DxPopupAdd, { DxToolbarItem } from 'devextreme-vue/popup';
import { DxItem, DxForm, DxLabel } from 'devextreme-vue/form';
import {
    DxColumn,
    DxDataGrid,
    DxFilterRow,
    DxLoadPanel,
    DxPaging,
    DxSelection,
    DxSorting,
    DxStateStoring,
    DxToolbar,
    DxEditing,
    DxPopup,
    DxItem as DxItemForm,
    DxForm as DxFormGrid,
    DxValidationRule,
    DxRequiredRule,
    DxLookup,
} from 'devextreme-vue/data-grid';
import 'devextreme/dist/css/dx.light.css';
import 'devextreme/dist/css/dx.common.css';
import notify from 'devextreme/ui/notify';
import { locale, loadMessages } from 'devextreme/localization';
import ResponseData from '@/types/responseData';
import AUTH_DrepturiCustom from '@/services/AUTH/AUTH_DrepturiCustom';
import AUTH_DrepturiModule from '@/services/AUTH/AUTH_DrepturiModule';
import DrepturiCustom from '@/types/auth/drepturiCustom';
import { height } from 'devexpress-reporting/scopes/reporting-designer-bands-metadata';

export default defineComponent({
    components: {
        DxToolbar,
        DxDataGrid,
        DxColumn,
        DxSorting,
        DxSelection,
        DxFilterRow,
        DxStateStoring,
        DxLoadPanel,
        DxPaging,
        DxButton,
        DxItem,
        DxPopup,
        DxForm,
        DxLabel,
        DxEditing,
        DxPopupAdd,
        DxToolbarItem,
        DxItemForm,
        DxFormGrid,
        DxValidationRule,
        DxRequiredRule,
        DxLookup,
    },
    data() {
        return {
            dsDrepturiCustom: [] as DrepturiCustom[],
            dsModule: [] as any[],
            isModalVisible: false,
            editId: null as string | null,
            formData: {
                ID: null,
                Nume: '',
                Cod: '',
                Explicatie: '',
                Meniu: true,
                MeniuConfig: '',
                ModulID: null as string | null,
            },
            deleteConfirmationMessage: "Sigur doriți să ștergeți această înregistrare?",
            dataGridRef: ref<DxDataGrid | null>(null),
            successButtonOptions: {
                type: 'success',
                stylingMode: 'contained',
                text: 'Salvează',
                onClick: () => {
                    this.onSaveEdit();
                },
            },
            dangerButtonOptions: {
                type: 'danger',
                stylingMode: 'contained',
                text: 'Închide',
                onClick: () => {
                    this.onCancelEdit();
                },
            },
            customTitleTemplate() {

                return `<div style="background-color: #ff2c21; font-size: 16px; float: right; height:47px; width:570px; color: white;
                        font-weight: bold;  padding: 12px; padding-right: 450px;  position: relative;  left: 30px;">
                          Editare
                        </div>`;
            },
        };
    },
    methods: {
        loadModules() {
            AUTH_DrepturiModule.getModule()
                .then((r: any) => { this.dsModule = r.data ?? []; })
                .catch(console.error);
        },
        getDrepturiCustom() {
            AUTH_DrepturiCustom.get()
                .then((response: ResponseData) => {
                    this.dsDrepturiCustom = response.data.filter((item: any) => item.Meniu === true || item.Meniu === 1);
                })
                .catch((e: Error) => {
                    console.log(e)
                });
        },
        onSelectionChanged(e: any) {
            const selectedRow = e.selectedRowsData[0];
            this.$emit('selection-changed', selectedRow.ID);
        },
        onAddClick() {
            this.isModalVisible = true;
        },


        onCancel() {
            this.isModalVisible = false;
        },
        setDeleteConfirmationMessage() {
            const dataGrid = this.$refs.dataGridRef?.instance;
            dataGrid.option('editing', {
                allowUpdating: true,
                allowDeleting: true,
                mode: 'popup',
                texts: {
                    confirmDeleteMessage: this.deleteConfirmationMessage,
                    confirmDeleteTitle: "Confirmare Ștergere",
                }
            });
        },
        onClick() {
            this.isModalVisible = true;
        },
        onColumnChooserClick() {
            const dataGrid = this.$refs.dataGrid.instance;
            dataGrid.showColumnChooser();
        },
        onRefreshClick() {
            this.getDrepturiCustom();
            notify('Datele au fost actualizate cu succes!', 'success', 1000)
        },

        onSaveAdd() {
            if (!this.formData.Nume || this.formData.Nume.trim() === '') {
                notify('Completați câmpul obligatoriu "Nume"!', 'error', 1000);
                return;
            }
            if (!this.formData.Cod || this.formData.Cod.trim() === '') {
                notify('Completați câmpul obligatoriu "Cod"!', 'error', 1000);
                return;
            }
            if (!this.formData.MeniuConfig || this.formData.MeniuConfig.trim() === '') {
                notify('Completați câmpul obligatoriu "Meniu Configurat"!', 'error', 1000);
                return;
            }
            const savePromise = this.$refs.dataGridRef?.instance?.saveEditData();
            console.log(this.formData);

            const body = {
                ...this.formData,
                Meniu: this.formData.Meniu ?? true
            };

            AUTH_DrepturiCustom.save(body)
                .then((response) => {
                    this.isModalVisible = false;
                    notify('Datele au fost salvate cu succes!', 'success', 1000);
                    this.formData = { ID: null, Nume: '', Cod: '', Explicatie: '', Meniu: true, MeniuConfig: '', ModulID: null };
                    this.getDrepturiCustom();
                })
                .catch((error) => {
                    console.error(error);
                    notify('Datele există deja!', 'error', 1000);
                });
        },
        onEditingStart(e: any) {
            this.editId = e.key.ID;
            this.formData = { ...e.data };
        },
        onSaveEdit() {
            //determin id ul randului selectat
            const id = this.editId ?? this.formData.ID;
            if (!id) {
                notify('Nu am ID-ul rândului de actualizat.', 'error', 2000);
                return;
            }
            //din grid trag lista de schimbari facute
            const grid = this.$refs.dataGridRef?.instance;
            const changes = grid ? (grid.option('editing.changes') || []) : [];
            const firstChange = changes[0] || null;

            //  delta = aici am  doar campurile modificate în popup adica MeniuConfig
            const delta = firstChange?.data || {};

            //  payload final = valorile initiale adica cele din formData + modificările din popup
            //    tine minte si campurile disabled care nu apar în delta
            const payload = { ...this.formData, ...delta };

            AUTH_DrepturiCustom.update(id, payload)
                .then(() => {
                    // curata editare din grid și închide popup-ul
                    if (grid) {
                        grid.cancelEditData();   // inchide popup + goleste tot ce am facut in editing.changes vezi mai sus
                        grid.refresh();
                    }
                    this.isModalVisible = false;

                    notify('Datele au fost actualizate cu succes!', 'success', 1000);

                    this.formData = {
                        ID: null,
                        Nume: '',
                        Cod: '',
                        Explicatie: '',
                        Meniu: true,
                        MeniuConfig: '',
                        ModulID: null,
                    };

                    this.getDrepturiCustom();
                })
                .catch((error) => {
                    console.error(error);
                    notify('Eroare la salvare', 'error', 2000);
                });
        },
        onCancelEdit() {
            this.dataGridRef?.instance?.cancelEditData();
        },
        onRowRemoving(e: any) {
            const id = e.key ?? e.data?.id;
            e.cancel = new Promise((resolve) => {
                AUTH_DrepturiCustom.delete(id)
                    .then(() => { notify('Datele au fost șterse cu succes!', 'success', 2000); resolve(false); })
                    .catch(() => { notify('A apărut o eroare la ștergere!', 'error', 2000); resolve(true); });
            });
        },
        onRowInserting() {
            notify('Datele au fost adăugate cu succes!', 'success', 1000)
        },
    },
    mounted() {
        this.getDrepturiCustom();
        this.loadModules();
        this.dataGridRef = this.$refs.dataGridRef as DxDataGrid;
        this.setDeleteConfirmationMessage();
        loadMessages({
            "ro": {
                "Yes": "Da",
                "No": "Nu",
            }
        });
        locale('ro');
    },
});
</script>
<style scoped>
.border {
    border-radius: 8px;
}
</style>
